import React, { useEffect } from 'react';
import { Hero } from './components/Hero';
import { PainPoints } from './components/PainPoints';
import { Modules } from './components/Modules';
import { Reviews } from './components/Reviews';
import { Bonuses } from './components/Bonuses';
import { ComparisonTable } from './components/ComparisonTable';
import { Testimonials } from './components/Testimonials';
import { FinalOffer } from './components/FinalOffer';
import { Objections } from './components/Objections';
import { PurchasePopup } from './components/PurchasePopup';
import { initMetaPixel } from './utils/metaPixel';
import { COURT_BG } from './data/content';
export function App() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <div className="relative min-h-full w-full overflow-hidden bg-[var(--pb-navy)]" data-id="element-0">
      {/* Blurred pickleball court background */}
      <div aria-hidden className="pointer-events-none fixed inset-0 z-0 bg-cover bg-center" style={{
      backgroundImage: `url(${COURT_BG})`
    }} data-id="element-1" />
      <div aria-hidden className="pointer-events-none fixed inset-0 z-0 bg-[#08111f]/95 backdrop-blur-2xl" data-id="element-2" />

      {/* Content */}
      <main className="landing-content relative z-10 mx-auto w-full max-w-lg" data-id="element-3">
        <Hero data-id="element-4" />
        <PainPoints data-id="element-5" />
        <Modules data-id="element-6" />
        <Reviews data-id="element-7" />
        <Bonuses data-id="element-8" />
        <ComparisonTable data-id="element-9" />
        <Testimonials data-id="element-10" />
        <FinalOffer data-id="element-11" />
        <Objections data-id="element-12" />

        <footer className="px-5 pb-24 pt-4 text-center" data-id="element-13">
          <p className="text-xs text-white/65" data-id="element-14">
            © {new Date().getFullYear()} Pickleball Coach 360 · All rights
            reserved.
          </p>
        </footer>
      </main>

      <PurchasePopup data-id="element-15" />
    </div>;
}